<template>
<div class="flow-ball" :style="styles">
  <div :class="{ point1: dir == 1, point2: dir==2, point3: dir==3, point4: dir==4, point5: dir==5, point6: dir==6, point7: dir==7, point8: dir==8 }"></div>
</div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      default () {
        return [];
      }
    },
    styles: {
      type: Object
    },
    dir: {
      type: Number,
      default: 1
    },
  },
  data() {
    return {
      len: '100px'
    };
  },
  methods: {},
  mounted() {}
};
</script>

<style lang="scss">
@import './style/global.scss';

// $css_len:var(--width,100px);
// $css_color:#85acef;
.flow-ball {
  display: inline-block;
  // width: 204px;
  background: $css_color;
  position: absolute;
  overflow: hidden;
  // top: 150px;
  padding: 1px 2px;
  transform: rotate(36deg);
  border-radius: 4px;

  /* 阿尔法*/
  .point1 {
    width: 4px;
    height: 4px;
    background-color: #62dfed;
    animation-name: example1;
    animation-duration: 3s;
    border-radius: 50%;
    animation-iteration-count: infinite;
    position: relative;
  }

  .point2 {
    width: 4px;
    height: 4px;
    background-color: #62dfed;
    animation-name: example2;
    animation-duration: 3s;
    border-radius: 50%;
    animation-iteration-count: infinite;
    position: relative;
  }

  .point3 {
    width: 4px;
    height: 4px;
    background-color: #62dfed;
    animation-name: example1;
    animation-duration: 3s;
    border-radius: 50%;
    animation-iteration-count: infinite;
    position: relative;
  }

  /* 蓝思*/
  .point4 {
    width: 4px;
    height: 4px;
    background-color: #62dfed;
    animation-name: example4;
    animation-duration: 3s;
    border-radius: 50%;
    animation-iteration-count: infinite;
    position: relative;
  }

  .point5 {
    width: 4px;
    height: 4px;
    background-color: #62dfed;
    animation-name: example5;
    animation-duration: 3s;
    border-radius: 50%;
    animation-iteration-count: infinite;
    position: relative;
  }

  .point6 {
    width: 4px;
    height: 4px;
    background-color: #62dfed;
    animation-name: example6;
    animation-duration: 3s;
    border-radius: 50%;
    animation-iteration-count: infinite;
    position: relative;
  }

  .point7 {
    width: 4px;
    height: 4px;
    background-color: #62dfed;
    animation-name: example7;
    animation-duration: 3s;
    border-radius: 50%;
    animation-iteration-count: infinite;
    position: relative;
  }

  .point8 {
    width: 4px;
    height: 4px;
    background-color: #62dfed;
    animation-name: example8;
    animation-duration: 3s;
    border-radius: 50%;
    animation-iteration-count: infinite;
    position: relative;
  }
}

@keyframes example1 {
  0% {
    background-color: #62dfed;
    left: 0px;
    top: 0px;
  }

  95% {
    background-color: #62dfed;
    left: $css_len;
    opacity: 1;
    top: 0px;
  }

  100% {
    background-color: #62dfed;
    opacity: 0;
    left: $css_len;
    top: 0px;
  }
}

@keyframes example2 {
  0% {
    background-color: #62dfed;
    left: 0px;
    top: 0px;
  }

  95% {
    background-color: #62dfed;
    left: $css_len2;
    opacity: 1;
    top: 0px;
  }

  100% {
    background-color: #62dfed;
    opacity: 0;
    left: $css_len2;
    top: 0px;
  }
}

@keyframes example3 {
  0% {
    background-color: #62dfed;
    left: 0px;
    top: 0px;
  }

  95% {
    background-color: #62dfed;
    left: $css_len3;
    opacity: 1;
    top: 0px;
  }

  100% {
    background-color: #62dfed;
    opacity: 0;
    left: $css_len3;
    top: 0px;
  }
}

@keyframes example4 {
  0% {
    background-color: #62dfed;
    left: 0px;
    top: 0px;
  }

  95% {
    background-color: #62dfed;
    left: $css_len4;
    opacity: 1;
    top: 0px;
  }

  100% {
    background-color: #62dfed;
    opacity: 0;
    left: $css_len4;
    top: 0px;
  }
}

@keyframes example5 {
  0% {
    background-color: #62dfed;
    left: 0px;
    top: 0px;
  }

  95% {
    background-color: #62dfed;
    left: $css_len5;
    opacity: 1;
    top: 0px;
  }

  100% {
    background-color: #62dfed;
    opacity: 0;
    left: $css_len5;
    top: 0px;
  }
}

@keyframes example6 {
  0% {
    background-color: #62dfed;
    left: 0px;
    top: 0px;
  }

  95% {
    background-color: #62dfed;
    left: $css_len6;
    opacity: 1;
    top: 0px;
  }

  100% {
    background-color: #62dfed;
    opacity: 0;
    left: $css_len6;
    top: 0px;
  }
}

@keyframes example7 {
  0% {
    background-color: #62dfed;
    left: 0px;
    top: 0px;
  }

  95% {
    background-color: #62dfed;
    left: $css_len7;
    opacity: 1;
    top: 0px;
  }

  100% {
    background-color: #62dfed;
    opacity: 0;
    left: $css_len7;
    top: 0px;
  }
}

@keyframes example8 {
  100% {
    background-color: #62dfed;
    left: 0px;
    top: 0px;
  }

  5% {
    background-color: #62dfed;
    left: $css_len8;
    opacity: 1;
    top: 0px;
  }

  0% {
    background-color: #62dfed;
    opacity: 0;
    left: $css_len8;
    top: 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/svolt/project/components/nanwang/flow-ball.vue